import React, { useEffect, useState, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setMixSelectedLeagues, setBodySelectedLeagues, playSong } from '../../common/actions/common.actions';
import { MdOutlineChecklist, MdOutlineCheckCircle } from "react-icons/md";

const FilterView = ({ onClose, leagues, onLeagueSelection, events, mixBody }) => {
  const dispatch = useDispatch();
  const { mixSelectedLeagues, bodySelectedLeagues } = useSelector((state) => state.common);
  const [allLeaguesSelected, setAllLeaguesSelected] = useState(true);
  const isWideWindow = window.innerWidth >= 1024;

  const setSelectedLeagueData = useCallback((data) => {
    mixBody === 'maung'
      ? dispatch(setMixSelectedLeagues(data))
      : dispatch(setBodySelectedLeagues(data));
  }, [dispatch]);

  useEffect(() => {
    const selectedLeagues = mixBody === 'maung' ? mixSelectedLeagues : bodySelectedLeagues;
    if (leagues?.length && selectedLeagues?.length) {
      const leagueNames = leagues.map((l) => l.leagueName);
      const isSelectAll =
        leagueNames.every((name) => selectedLeagues.includes(name)) &&
        selectedLeagues.every((name) => leagueNames.includes(name));
      setAllLeaguesSelected(isSelectAll);
      setSelectedLeagueData(selectedLeagues);
    }
  }, [leagues]);

  const handleSongClick = () => dispatch(playSong());

  const handleCheckboxChange = (leagueName) => {
    const selectedLeagues = mixBody === 'maung' ? mixSelectedLeagues : bodySelectedLeagues;
    const updated =
      allLeaguesSelected
        ? leagues.filter((l) => l.leagueName !== leagueName).map((l) => l.leagueName)
        : selectedLeagues.includes(leagueName)
          ? selectedLeagues.filter((name) => name !== leagueName)
          : [...selectedLeagues, leagueName];
    setSelectedLeagueData(updated);
    setAllLeaguesSelected(updated.length === leagues.length);
  };

  useEffect(() => {
    const selectedLeagues = mixBody === 'maung' ? mixSelectedLeagues : bodySelectedLeagues;
    if (selectedLeagues?.length === leagues?.length) {
      setAllLeaguesSelected(true);
    }
  }, [mixSelectedLeagues, bodySelectedLeagues, leagues]);

  const handleOKClick = () => {
    const selectedLeagues = mixBody === 'maung' ? mixSelectedLeagues : bodySelectedLeagues;
    handleSongClick();
    const selection = allLeaguesSelected
      ? leagues.map((l) => l.leagueName)
      : selectedLeagues;
    onLeagueSelection(selection);
    setSelectedLeagueData(selection);
    onClose();
  };

  const handleAllSelectedChange = () => {
    const selected = allLeaguesSelected ? [] : leagues.map((l) => l.leagueName);
    setSelectedLeagueData(selected);
    setAllLeaguesSelected(!allLeaguesSelected);
  };

  return (
    <div className="h-screen overflow-auto bg-gradient_start dark:bg-bg_header_dark text-gray-800 dark:text-gray-100">
      {/* Header */}
      <div className={`fixed top-0 left-0 right-0 z-50 px-6 py-4 bg-header_green text-wback dark:bg-slate-800 shadow-md flex items-center justify-between ${isWideWindow ? 'max-w-7xl mx-auto' : ''}`}>
        <div className="flex items-center gap-2">
          <MdOutlineChecklist size={26} className="text-wback" />
          <h2 className="text-lg font-semibold">
            {leagues.length} League / {events} Events
          </h2>
        </div>
        <button
          className="flex items-center gap-2 px-4 py-1 rounded-full bg-primary text-wback text-sm hover:opacity-90 transition-all"
          onClick={handleOKClick}
        >
          <MdOutlineCheckCircle size={18} />
          OK
        </button>
      </div>

      {/* Select All */}
      <div className="mt-24 px-6 py-3 border-b dark:border-gray-600 flex items-center gap-3">
        <input
          type="checkbox"
          checked={allLeaguesSelected}
          onChange={handleAllSelectedChange}
          className="accent-blue-600 w-4 h-4"
        />
        <span className="text-base text-wback font-medium">
          {allLeaguesSelected ? 'Deselect All' : 'Select All'}
        </span>
      </div>

      {/* League List */}
      <ul className="px-6 py-2 overflow-y-scroll max-h-[70vh] space-y-2 text-wback">
        {leagues.map((league, index) => (
          <li key={league.leagueId} className="flex items-center gap-3">
            <input
              type="checkbox"
              id={`league-${league.leagueId}`}
              checked={
                allLeaguesSelected ||
                (mixBody === 'maung'
                  ? mixSelectedLeagues.includes(league.leagueName)
                  : bodySelectedLeagues.includes(league.leagueName))
              }
              onChange={() => handleCheckboxChange(league.leagueName)}
              className="accent-blue-500 w-4 h-4"
            />
            <label
              htmlFor={`league-${league.leagueId}`}
              className="text-sm font-medium"
            >
              {league.leagueName}
            </label>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default FilterView;
